import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { logger } from '@zep/core-logger';
import { ChevronRightIcon } from '@zep/icons';
export const TemplateFilterBanner = () => {
  const {
    i18n,
    t
  } = useTranslation(['common']);
  const handleClickBanner = () => {
    logger.track('create_sales_banner');
  };
  const bannerLink = useMemo(() => {
    switch (i18n.resolvedLanguage) {
      case 'ko':
        return '/home/contact';
      case 'ja':
        return 'https://contact.zep.us/premium.plan.jp';
      default:
        return 'https://contact.zep.us/premium.plan.en';
    }
  }, [i18n.resolvedLanguage]);

  // 하이라이트할 텍스트를 정의
  const highlightText = useMemo(() => {
    switch (i18n.resolvedLanguage) {
      case 'ko':
        return '공식 파트너스';
      case 'ja':
        return 'パートナーズ';
      default:
        return 'Certified Partner';
    }
  }, [i18n.resolvedLanguage]);

  // 텍스트를 하이라이트 부분과 나머지로 분리
  const renderHighlightedText = (text: string) => {
    const parts = text.split(highlightText);
    if (parts.length === 1) {
      // 하이라이트 텍스트가 없는 경우
      return <span>{text}</span>;
    }
    return <>
        {parts[0]}
        <span className="text-[#007CDE]">{highlightText}</span>
        {parts[1]}
      </>;
  };
  const isExternalLink = bannerLink.startsWith('http');
  return <a href={bannerLink} target={isExternalLink ? '_blank' : '_self'} rel={isExternalLink ? 'noopener noreferrer' : undefined} onClick={handleClickBanner} className="mt-[12px] block cursor-pointer rounded-[12px] border border-[rgba(39,38,46,0.08)] bg-[#EBF6FF] px-[14px] py-[10px] shadow-[0_1px_4px_0_rgba(42,39,65,0.08)]" data-sentry-component="TemplateFilterBanner" data-sentry-source-file="TemplateFilterBanner.tsx">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-[2px]">
          <p className="text-[11px] font-medium text-[#5E6066]">
            {t('common:create_space.footer_banner.text')}
          </p>
          <div className="flex items-center justify-between">
            <p className="text-[12px] font-semibold text-[#27262E]">
              {renderHighlightedText(t('common:create_space.footer_banner.text_highlight'))}
            </p>
          </div>
        </div>
        <ChevronRightIcon className="size-[20px] text-gray-600" data-sentry-element="ChevronRightIcon" data-sentry-source-file="TemplateFilterBanner.tsx" />
      </div>
    </a>;
};